import template from './documentMergeFields.template.html';

export default {
  template,
  bindings: {
    mergeFields: '<',
    onClosed: '&'
  },
controller: class controller {
    constructor($mdMedia, clipboard, uiService) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.reportsIsActive = true;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.mergeProperties = ctrl.mergeFields;
        ctrl.searchTerm = '';
        ctrl.reportsIsActive = true;
        ctrl.isReady = false;
        if (ctrl.mergeProperties?.length) {
          ctrl.isReady = true;
        }
      };

      ctrl.getFieldName = (name, index) => {
        const fieldName = name.split(' - ');
        return fieldName[index] !== '' ? fieldName[index] : fieldName[index - 1];
      };

      ctrl.copyToClipboard = (property) => {
        clipboard.copyText(`{${property.key}}`);
        uiService.toast({
          text: {
            p1: ctrl.getFieldName(property.name, 2),
            p2: `key {${property.key}}`,
            p3: 'copied to clipboard'
          }
        });
      };

      ctrl.reportClose = () => {
        ctrl.reportsIsActive = false;
        ctrl.onClosed();
      };

      ctrl.setCaretClass = (isView) => (isView ? 'down' : 'up');

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = (changes) => {
        if (changes.mergeFields && changes.mergeFields.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
